import { axios } from '@/lib/axios';

export const APIresetPassword = (password: string, token: string): Promise<boolean> => {
    return axios.put('/auth/password-reset', { password, token });
};
